export const  message = {
  language:`language`,
  app_name:`Evebot-Fantasia`,
  next: `next`,
  device_id: `Device ID`,
  device_id_placeholder:`Type in device Id`,
  device_id_not_valid:`Device number is not valid`,
  device_id_not_exist:`The device number does not exist`,
  upload_phone:`Upload from Mobile Phone`,
  group_id_not_exist:`Image group does not exist`,
  join_id_not_exist:'param error',
  image_edit:`Picture editing`,
  image_not_exist:`Image does not exist`,
  image_upload_success:`We've received your image, busy preparing you coffee now.`,
  image_upload_error:'Image upload failed',
  image_code:'image code',
  image_code2:'Picture No',
  confirm:`Confirm`,
  uploading:`Uploading`,
  cancel:`cancel`,
  finish:`Finish`,
  another:`Get another one!`,
  small_ticket:`Small ticket`,
  small_ticket_placeholder:`Please enter a small ticket`,
  small_not_verify:`Please enter numbers and English letters`,
  website_error:`Website error, please check again`,
  add_text:`Add text`,
  add_text_first:`Please add text first`,
  enter_text:`please enter text`,
  prompt_box:`Prompt box`,
  gallery:'Gallery',
  upload:'Upload',
  token_error:'Token verification failed',
  image_list:'image list',
  select_prompt:"The images will be sent to the coffee printer directly, the server will not save any personal information.",

  setting:'Setting',
  watermark_switch:'Watermark Switch',
  watermark_upload:'Watermark Upload',
  image_max:'The image you upload is too big, please choose a smaller one, or reduce the size by screen shot.',
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js